import { toUserMessage } from 'utils/apiErrorHelper';
import type { IFaceSyncAsyncCreateResponseProps } from 'services/Jobs/types';
import { api } from '../DefaultService';
import { IPaginationParams } from '../types';
import {
  IRecognitionChangeTypeParams,
  IRecognitionDeleteParams,
  IRecognitionFilterParams,
  IRecognitionSimpleProps,
} from './types';

const ENDPOINT = 'v1/recognitions';

export const getAllRecognitionsByLicenseAsync = async (
  pagination?: IPaginationParams,
  filter?: IRecognitionFilterParams,
): Promise<IRecognitionSimpleProps[]> => {
  return await api
    .get(`${ENDPOINT}/getAllByLicense`, {
      params: { ...pagination, ...filter },
    })
    .then((response) => response.data)
    .catch((error) => {
      throw new Error(
        error?.response?.data?.message || 'Erro interno do servidor!',
      );
    });
};

export const getAllRecognitionsByLicenseCountAsync = async (
  filter: IRecognitionFilterParams,
): Promise<number> => {
  return await api
    .get(`${ENDPOINT}/getAllByLicense/count`, { params: { ...filter } })
    .then((response) => response.data)
    .catch((error) => {
      throw new Error(
        error?.response?.data?.message || 'Erro interno do servidor!',
      );
    });
};

export const deleteRecognitionAsync = async ({
  id,
  type,
}: IRecognitionDeleteParams) => {
  await api
    .delete(`${ENDPOINT}/${id}`, { params: { discriminator: type } })
    .catch((error) => {
      throw new Error(
        error?.response?.data?.message || 'Erro interno do servidor!',
      );
    });
};

/**
 * Troca o tipo de um cadastro preservando o mesmo Id, e enfileira a
 * sincronizacao com os dispositivos. Diferente dos demais endpoints de
 * Recognition, envia JSON puro (nao multipart) por nao receber imagem.
 */
export const changeRecognitionTypeAsync = async ({
  id,
  data,
}: IRecognitionChangeTypeParams): Promise<IFaceSyncAsyncCreateResponseProps> => {
  try {
    const response = await api.patch(`${ENDPOINT}/${id}/change-type/async`, data, {
      timeout: 0,
    });
    return response.data;
  } catch (error) {
    throw new Error(toUserMessage(error));
  }
};
